import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
// import { Link } from "react-router-dom";
import useLocalStorage from "use-local-storage";
import "./Main.scss";
import { faSun, faMoon } from "@fortawesome/free-solid-svg-icons";

const Main = () => {
  const defaultDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const [theme, setTheme] = useLocalStorage(
    "theme",
    defaultDark ? "dark" : "light"
  );

  const switchTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
  };

  return (
    <div className="main" data-theme={theme}>
      <div className="mid-section">
        <div className="header">
          <button className="switcher" onClick={switchTheme}>
            {theme === "light" ? (
              <FontAwesomeIcon size={"2x"} icon={faMoon} className="icon" />
            ) : (
              <FontAwesomeIcon size={"2x"} icon={faSun} className="icon" />
            )}
          </button>
          {/* <button className="home-button">Home</button> */}
        </div>
        <div className="section">
          <div className="section-title">
            <p>About</p>
          </div>
          <div className="section-text">
            <p>{"Hi, I'm Shehjad."}</p>
            <p>
              {"I'm currently building and scaling "}
              <a
                className="styled-link tenable hoverable"
                href="https://www.tenable.to/"
                target="_blank"
                rel="noreferrer"
              >
                {"Tenable"}
              </a>
              {", an intuitive and fair payments layer for the agentic web. On the side I run "}
              <a
                className="styled-link agency hoverable"
                href="https://www.anzu.agency/"
                target="_blank"
                rel="noreferrer"
              >
                {"Anzu Studio"}
              </a>
              {", a web design agency, and prop trade stocks + crypto."}
            </p>
            <p>
              {"I previously deployed linear equity derivative trading strategies at "}
              <a
                className="styled-link undisclosed hoverable"
                href="https://www.shjdkhn.xyz/"
                target="_blank"
                rel="noreferrer"
              >
                {"[undisclosed market maker]"}
              </a>
              {" after studying Mathematics at the "}
              <a
                className="styled-link waterloo hoverable"
                href="https://uwaterloo.ca"
                target="_blank"
                rel="noreferrer"
              >
                {"University of Waterloo"}
              </a>
              {". Before that, I interned as a software engineer/quant at "}
              <a
                className="styled-link microsoft hoverable"
                href="https://www.microsoft.com/"
                target="_blank"
                rel="noreferrer"
              >
                {"Microsoft"}
              </a>
              {", "}
              <a
                className="styled-link goldmansachs hoverable"
                href="https://www.goldmansachs.com/"
                target="_blank"
                rel="noreferrer"
              >
                {"Goldman Sachs"}
              </a>
              {", "}
              <a
                className="styled-link bain hoverable"
                href="https://www.bain.com/"
                target="_blank"
                rel="noreferrer"
              >
                {"Bain & Co."}
              </a>
              {", "}
              <a
                className="styled-link mercari hoverable"
                href="https://www.mercari.com/"
                target="_blank"
                rel="noreferrer"
              >
                {"Mercari"}
              </a>
              {", and "}
              <a
                className="styled-link rbc hoverable"
                href="https://www.rbccm.com/en/"
                target="_blank"
                rel="noreferrer"
              >
                {"RBC Capital Markets"}
              </a>
              {"."}
            </p>

            <p>
              {"During school, I was a venture scout for "}
              <a
                className="styled-link anthos hoverable"
                href="https://anthoscapital.com/"
                target="_blank"
                rel="noreferrer"
              >
                {"Anthos Capital"}
              </a>
              {". I helped the firm invest in early-stage companies in the gaming industry. Notable deals include the development studios behind "}
              <a
                className="styled-link discord hoverable"
                href="https://discord.com/"
                target="_blank"
                rel="noreferrer"
              >
                {"Discord"}
              </a>
              {", "}
              <a
                className="styled-link vrchat hoverable"
                href="https://store.steampowered.com/app/438100/VRChat/"
                target="_blank"
                rel="noreferrer"
              >
                {"VRChat"}
              </a>
              {", and "}
              <a
                className="styled-link palia hoverable"
                href="https://palia.com/"
                target="_blank"
                rel="noreferrer"
              >
                {"Palia"}
              </a>
              {"."}
            </p>
            <p>{"In my free time I love to work out, travel, read, and play a lot of action RPGs. I also occasionally write & produce alt-RnB music."}</p>
          </div>
        </div>
        {/* <div className="section">
          <div className="section-title">
            <p>Writing</p>
          </div>
          <div className="section-text">
            <p>
              {"You can find some of my recent writing "}
              <Link className="link" to="/writing">
                here.
              </Link>
            </p>
          </div>
        </div> */}
        <div className="section">
          <div className="section-title">
            <p>Email</p>
          </div>
          <div className="section-text">
            <p>
              <div className="links-section">
                <p><a className="link" href="mailto:shehjad@tenable.to" target="_blank" rel="noreferrer">shehjad[at]tenable.to</a></p>
                <p><a className="link" href="mailto:shehjad@anzu.agency" target="_blank" rel="noreferrer">shehjad[at]anzu.agency</a></p>
                <p><a className="link" href="mailto:shehadrakhan@gmail.com" target="_blank" rel="noreferrer">shehadrakhan[at]gmail.com</a></p>
              </div>
            </p>
          </div>
        </div>
        <div className="section">
          <div className="section-title">
            <p>Links</p>
          </div>
          <div className="section-text">
            <p>
              <div className="links-section">
                <a className="link" href="https://www.instagram.com/shjd.khn/" target="_blank" rel="noreferrer">Instagram</a>{`   `}
                <a className="link" href="https://www.linkedin.com/in/shehjad-khan/" target="_blank" rel="noreferrer">LinkedIn</a>{`   `}
                <a className="link" href="https://x.com/shjdkhn" target="_blank" rel="noreferrer">X</a>{`   `}
                <a className="link" href="https://github.com/shjdkhn" target="_blank" rel="noreferrer">GitHub</a>{`   `}
              </div>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
